export default __webpack_public_path__ + "static/media/collections_1.c3f772b4.jpg";